import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getClosures = async (dataOrigen, refrescar, api, token, body, config, ejecutar, filtrarPagos) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.closures.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {
    //hay escenarios por ejemplo cuando es manager
    //y aun no tiene todos los parametros solicitados
    if (ejecutar) {
      const response = await axios(configws)
      data = { closures: base64ToString(response) }
    }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, status = null, sort, sortColumn } = config
  /* eslint-enable */

  if (filtrarPagos) {
    data.closures = data.closures.filter(closure => { return closure.fee_payments.length > 0 })
  }

  const dataAsc = data.closures.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(closure => {
    
    const cambiaEstado = (status) => {

      if (status < 1000) {
        return closure.closure_status === (status > 0 ? Number(status) : closure.closure_status)
      }

      if (status === 1000) {
        return closure.closure_charged_status === 0
      }

      if (status === 1001) {
        return closure.closure_charged_status === 2 || closure.closure_charged_status === 4
      }

      if (status === 1002) {
        return closure.closure_charged_status === 1
      }

      if (status === 1003) {
        return closure.closure_charged_status === 0 || closure.closure_charged_status === 1
      }

      if (status === 1004) {
        return closure.closure_charged_status === 1 || closure.closure_charged_status === 2 || closure.closure_charged_status === 4
      }
    }

    const getLatestDate = (comision_data) => {
      if (comision_data.length === 0) {
          return ''
      }
      
      return comision_data.reduce((max, obj) => (obj.comision_id > max.comision_id ? obj : max), comision_data[0]).date
    }

    return (
        (
          
          String(closure.id_closure).toLowerCase().includes(queryLowered) ||
          (closure.id_closure_coc1 && String(closure.id_closure_coc1).toLowerCase().includes(queryLowered)) ||
          (closure.closure_date && closure.closure_date.toLowerCase().includes(queryLowered)) ||
          (closure.client_data.name && closure.client_data.name.toLowerCase().includes(queryLowered)) ||
          (closure.owner_data.name && closure.owner_data.name.toLowerCase().includes(queryLowered)) ||
          (closure.property_data.internal_key && closure.property_data.internal_key.toLowerCase().includes(queryLowered)) ||
          (closure.property_data.address && closure.property_data.address.toLowerCase().includes(queryLowered)) ||
          (!config.hasOwnProperty('type') ? (closure.user_uptake && closure.user_uptake.toLowerCase().includes(queryLowered)) : (config.type === 'charge' ? false : (closure.user_uptake && closure.user_uptake.toLowerCase().includes(queryLowered))))  ||
          (closure.user_closure && closure.user_closure.toLowerCase().includes(queryLowered)) ||
          (closure.closure_amount && String(closure.closure_amount).toLowerCase().includes(queryLowered)) ||
          (closure.commission_total && String(closure.commission_total).toLowerCase().includes(queryLowered)) ||
          (closure.total_commission_charged && String(closure.total_commission_charged).toLowerCase().includes(queryLowered)) ||
          (closure.commission_pending_collection && String(closure.commission_pending_collection).toLowerCase().includes(queryLowered)) ||
          (closure.closure_currency_iso && closure.closure_currency_iso.toLowerCase().includes(queryLowered)) ||
          (closure.commission_citymax && String(closure.commission_citymax).toLowerCase().includes(queryLowered)) ||
          (closure.comision_data && getLatestDate(closure.comision_data).toLowerCase().includes(queryLowered))
        ) 
        && 
        cambiaEstado(Number(status))
      )
  })

  return [
    200,
    {
      allData: data.closures,
      total: filteredData.length,
      closures: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page),
      dataFiltered: filteredData
    }
  ]  
}

// ------------------------------------------------
// GET: Return closure List for executive
// ------------------------------------------------
let dataExecutive = JSON.parse(localStorage.getItem("dataExecutive")) || { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1, last: new Date()}

mock.onGet('/apps/executive/closures').reply(async config => {
  const user = getUserData()

  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''
  let ejecutar   = false

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      //0 = todos
      cluster_id = config.cluster_id
      ejecutar = true
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
      ejecutar = true
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
      ejecutar = true
    }

    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country

    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }

    ejecutar   = true
  }
  
  const body = {
    cluster   : cluster_id,
    country   : country_id,
    office    : office_id,
    user      : user_id,
    date_from : config.startDate,
    date_to   : config.endDate,
    manager   : config.manager
  }

  if (localStorage.getItem("resetExecutive")) {
    if (localStorage.getItem("resetExecutive") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetExecutive")
  }

  const now = new Date()
  const diffInMinutes = (now - dataExecutive.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataExecutive = { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1, last: new Date()}
  }

  const result = await getClosures(dataExecutive, 1, GetApiCOC('getClosures'), user.token, body, config, ejecutar)

  dataExecutive = { closures: result[1].allData, startDate: config.startDate, endDate: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id, last: new Date()}

  localStorage.setItem("dataExecutive", JSON.stringify(dataExecutive))

  return result
})

const getClosure = async (config) => {

  // Get event id from URL
  const closureId = Number(config.url.substring(config.url.lastIndexOf('/') + 1))
  const user = getUserData()
  
  const body = {
    cluster:    user.usercoc.cluster,
    country:    user.usercoc.country,
    office:     user.usercoc.office_id,
    id_closure: closureId
  }

  const configws = {
    method: 'get',
    url:    GetApiCOC('getCOCclosure'),
    headers: { 
      Accept: 'application/json',
      obrientoken: user.token
    },
    params: body
  }

  const response = await axios(configws)

  if (response.data.Result === 'false') {
    return [200, null]
  }

  return [200, { closure: base64ToString(response) }]
}

// ------------------------------------------------
// GET: Return Single Closure for executive
// ------------------------------------------------
mock.onGet(/\/api\/executive\/closures\/\d+/).reply(async config => {
  return getClosure(config)
})

// ------------------------------------------------
// PUT: Update closure for executive
// ------------------------------------------------
mock.onPut(/\/api\/executive\/closures\/\d+/).reply(async config => {

  const closureId = Number(config.url.substring(config.url.lastIndexOf('/') + 1))
  const user = getUserData()

  let body = JSON.parse(config.data)

  body =  {
    id_closure: closureId,
    closure_info: Buffer.from(JSON.stringify(body)).toString('base64')
  }

  const configws = {
    method: 'post',
    url:    GetApiCOC('updateCOCclosure'),
    headers: { 
      Accept:'application/json',
      obrientoken: user.token
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// GET: Return closure List for manager
// ------------------------------------------------

let dataManager = JSON.parse(localStorage.getItem("dataManager")) || { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/manager/closures').reply(async config => {
    const user = getUserData()

    let cluster_id = ''
    let office_id  = ''
    let country_id = ''
    let user_id    = ''
    let ejecutar   = false

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      //0 = todos
      cluster_id = config.cluster_id
      ejecutar = true
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
      ejecutar = true
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
      ejecutar = true
    }

    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country

    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }
    
    ejecutar   = true
  }

  if (config.report) {
    if (config.user_id !== '') {
      user_id = config.user_id
    }
  }

  const body = {
    cluster:        cluster_id,
    country:        country_id,
    office:         office_id,
    user:           user_id,
    date_from:      config.startDate,
    date_to:        config.endDate,
    closure_status: '1|2|3'
  }

  if (localStorage.getItem("resetManager")) {
    if (localStorage.getItem("resetManager") === "true") {
      config.reset = true      
    }

    localStorage.removeItem("resetManager")
  }

  const now = new Date()
  const diffInMinutes = (now - dataExecutive.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  if (config.reset) {
    dataManager = { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getClosures(dataManager, 1, GetApiCOC('getCOCclosures'), user.token, body, config, ejecutar)

  dataManager = { closures: result[1].allData, startDate: config.startDate, endDate: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataManager", JSON.stringify(dataManager))

  return result 
})

// ------------------------------------------------
// GET: Return Single Closure for manager
// ------------------------------------------------
mock.onGet(/\/api\/manager\/closures\/\d+/).reply(async config => {
  return getClosure(config)
})

// ------------------------------------------------
// PUT: Update closure for manager
// ------------------------------------------------
mock.onPut(/\/api\/manager\/closures\/\d+/).reply(async config => {

  const closureId = Number(config.url.substring(config.url.lastIndexOf('/') + 1))
  const user = getUserData()

  const bodyClosure = JSON.parse(config.data)

  const body =  {
    id_closure: closureId,
    closure_info: Buffer.from(JSON.stringify(bodyClosure)).toString('base64')
  }

  const configws = {
    method: 'post',
    url:    GetApiCOC('updateCOCclosure'),
    headers: { 
      Accept:'application/json',
      obrientoken: user.token
    },
    data: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// PUT: Update closure for manager
// ------------------------------------------------
mock.onPut(/\/api\/commission\/closures\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('updateClosureValues'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// GET: Return closure List for charge
// ------------------------------------------------

let dataCharge = JSON.parse(localStorage.getItem("dataCharge")) || { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/charge/closures').reply(async config => {
  const user = getUserData()
  
  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''
  let ejecutar   = false

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      //0 = todos
      cluster_id = config.cluster_id
      ejecutar = true
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
      ejecutar = true
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
      ejecutar = true
    }

    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    
    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }

    ejecutar   = true
  }

  const body = {
    cluster:        cluster_id,
    country:        country_id,
    office:         office_id,
    user:           user_id,
    date_from:      config.startDate,
    date_to:        config.endDate,
    closure_status: '2|3'
  }

  if (localStorage.getItem("resetCharge")) {
    if (localStorage.getItem("resetCharge") === "true") {
      config.reset = true
    }

    localStorage.removeItem("resetCharge")
  }

  if (config.reset) {
    dataCharge = { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const now = new Date()
  const diffInMinutes = (now - dataCharge.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset = true
  }

  const result = await getClosures(dataCharge, 1, GetApiCOC('getCOCclosures'), user.token, body, config, ejecutar)

  dataCharge = { closures: result[1].allData, startDate: config.startDate, endDate: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataCharge", JSON.stringify(dataCharge))

  return result
})


// ------------------------------------------------
// GET: Return Single Closure for charge
// ------------------------------------------------
mock.onGet(/\/api\/charge\/closures\/\d+/).reply(async config => {
  return getClosure(config)
})

// ------------------------------------------------
// PUT: Add charge
// ------------------------------------------------
mock.onPut(/\/api\/charge\/closures\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertCommissiondata'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

mock.onPut(/\/api\/charge\/closures-manual\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('updateCommissiondataManual'),
    headers: { Accept: 'application/json' },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// PUT: Update closure for charge
// ------------------------------------------------
mock.onPut(/\/api\/charge\/closuresD\/\d+/).reply(async config => {

  const closureId = Number(config.url.substring(config.url.lastIndexOf('/') + 1))
  const user = getUserData()

  let body = JSON.parse(config.data)

  body =  {
    id_closure: closureId,
    closure_info: Buffer.from(JSON.stringify(body)).toString('base64')
  }

  const configws = {
    method: 'post',
    url:    GetApiCOC('updateCOCclosure'),
    headers: { 
      Accept:'application/json',
      obrientoken: user.token
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// DELETE: Delete charge
// ------------------------------------------------
mock.onDelete(/\/api\/charge\/closures\/\d+/).reply(async config => {

  const body = {
                internal_closure_id: config.internal_closure_id,
                comision_id:         config.comision_id
               }

  const configws = {
    method: 'post',
    url:    GetApiCOC('deleteCommissiondata'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// GET: Return closure List for payment
// ------------------------------------------------

let dataPayment = JSON.parse(localStorage.getItem("dataPayment")) || { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1}

mock.onGet('/apps/payment/closures').reply(async config => {

  const user = getUserData()

  let cluster_id = ''
  let office_id  = ''
  let country_id = ''
  let user_id    = ''
  let ejecutar   = false

  if (config.manager) {
    if (config.cluster_id !== -1 && config.cluster_id !== '') {
      //0 = todos
      cluster_id = config.cluster_id
      ejecutar = true
    }

    if (config.country_id !== -1 && config.country_id !== '') {
      country_id = config.country_id
      ejecutar = true
    }

    if (config.office_id !== -1 && config.office_id !== '') {
      office_id = config.office_id
      ejecutar = true
    }

    if (config.user_id !== -1 && config.user_id !== '') {
      user_id  = config.user_id
    }
  } else {
    cluster_id = user.usercoc.cluster
    office_id  = user.usercoc.office_id
    country_id = user.usercoc.country
    
    if (user.usercoc.role === 2) {
      user_id  = user.usercoc.user_id
    } else {
      user_id  = ""
    }

    ejecutar   = true
  }
  
  const body = {
    cluster:        cluster_id,
    country:        country_id,
    office:         office_id,
    user:           user_id,
    date_from:      config.startDate,
    date_to:        config.endDate,
    closure_status: 2
  }

  const now = new Date()
  const diffInMinutes = (now - dataPayment.last) / (1000 * 60)

  if (diffInMinutes >= 5) {
    config.reset =  true 
  }

  if (config.reset) {
    dataPayment = { closures: [], startDate: '', endDate: '', cluster: -1, country: -1, office: -1, user: -1 }
  }

  const result = await getClosures(dataPayment, 1, GetApiCOC('getCOCclosures'), user.token, body, config, ejecutar, true)

  dataPayment = { closures: result[1].allData, startDate: config.startDate, endDate: config.endDate, cluster: cluster_id, country: country_id, office: office_id, user: user_id }

  localStorage.setItem("dataPayment", JSON.stringify(dataPayment))

  return result
})


// ------------------------------------------------
// GET: Return Single Closure for payment
// ------------------------------------------------
mock.onGet(/\/api\/payment\/closures\/\d+/).reply(async config => {
  return getClosure(config)
})

// ------------------------------------------------
// PUT: Add payment
// ------------------------------------------------
mock.onPut(/\/api\/payment\/closures\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertfeepayment'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// GET: get payment
// ------------------------------------------------
mock.onGet(/\/api\/payment\/previewpage\/\df+\/\d+/).reply(async config => {
    
  const feePayment = Number(config.url.substring(config.url.lastIndexOf('/') + 2))
  const comisionId = String(config.url.substring(config.url.lastIndexOf('/') + 1))
  const user = getUserData()

  const body = {
    cluster:    user.usercoc.cluster,
    country:    user.usercoc.country,
    office:     user.usercoc.office_id,
    id_closure: comisionId,
    id_fee_payment: feePayment
  }

  const configws = {
    method: 'get',
    url:    GetApiCOC('getFeepayment'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// PUT: Add payment another
// ------------------------------------------------
mock.onPut(/\/api\/payment\/another\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertAnotherfeepayment'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// PUT: Add payment fee
// ------------------------------------------------
mock.onPut(/\/api\/payment\/fee\/\d+/).reply(async config => {
  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('insertFeepaymentdata'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})

// ------------------------------------------------
// DELETE: Delete charge
// ------------------------------------------------
mock.onDelete(/\/api\/payment\/closures\/\d+/).reply(async config => {

  const body = {
                internal_closure_id: config.internal_closure_id,
                comision_id:         config.comision_id
               }

  const configws = {
    method: 'post',
    url:    GetApiCOC('deleteCommissiondata'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})